export const typeOfPaymentMeansNonCash = (t)=>[

    { "label": t("invoice.transfer").toUpperCase({}), "paymentMeans": "31", paymentMeansValue: "TRANSFER"},
    { "label": t("invoice.account").toUpperCase(), "paymentMeans": "42", paymentMeansValue: "ACCOUNT" },
    { "label": t("invoice.otherPayment").toUpperCase(), "paymentMeans": "ZZZ", paymentMeansValue: "OTHER" },
    { "label": t("invoice.factoring").toUpperCase(), "paymentMeans": "30", paymentMeansValue: "FACTORING" },
    { "label": t("invoice.compensation").toUpperCase(), "paymentMeans": "97", paymentMeansValue: "COMPENSATION" },
    { "label": t("invoice.kind").toUpperCase(), "paymentMeans": "97", paymentMeansValue: "KIND" },
    { "label": t("invoice.waiver").toUpperCase(), "paymentMeans": "ZZZ", paymentMeansValue: "WAIVER" },

];
 
export const typeOfPaymentMeansCash =(t)=> [

    { "label": t("invoice.bankNote").toUpperCase(), "paymentMeans": "10", paymentMeansValue: "BANKNOTE", value: "10BANKNOTE" },
    { "label": t("invoice.card").toUpperCase(), "paymentMeans": "48", paymentMeansValue: "CARD", value: "48CARD" },
    { "label": t("invoice.check").toUpperCase(), "paymentMeans": "10", paymentMeansValue: "CHECK", value: "10CHECK" },
    { "label": t("invoice.order"), "paymentMeans": "10", paymentMeansValue: "ORDER", value: "10ORDER" },
    { "label": "SVOUCHER", "paymentMeans": "10", paymentMeansValue: "SVOUCHER", value: "10SVOUCHER" },
    { "label": "COMPANY", "paymentMeans": "10", paymentMeansValue: "COMPANY", value: "60COMPANY" },

];

export const buyerIDTypes = [
    { label: "NUIS", value: "1" },
    { label: "ID", value: "2" },
    { label: "PASS", value: "3" },
    { label: "VAT", value: "4" },
    { label: "TAX", value: "5" },
    { label: "SOC", value: "6" },
  ];

export const buyerIDTypesSelectOptions=(t)=>[
    { label: t("table.empty"), value: "empty" },
    { label: "NUIS", value: "NUIS" },
    { label: "ID", value: "ID" },
    { label: "PASS", value: "PASS" },
    { label: "VAT", value: "VAT" },
    { label: "TAX", value: "TAX" },
    { label: "SOC", value: "SOC" },
  ];


export const typeOfVatCategoryOptions = [
    { label: "0%", value: "0" },
    { label: "6%", value: "6" },
    { label: "10%", value: "10" },
    { label: "20%", value: "20" },
  ];


